// src/utils/emailUtils.js
import emailjs from 'emailjs-com';

// Replace with your EmailJS credentials
const SERVICE_ID = 'your_service_id';
const TEMPLATE_ID = 'your_template_id';
const USER_ID = 'your_user_id';

export const sendEmailNotification = async (to, message) => {
  const templateParams = {
    to_email: to,
    message: message,
  };
  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID);
    console.log('Email sent successfully');
  } catch (error) {
    console.error('Email sending failed:', error);
  }
};